// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (emergenciesnotmanaged-edit e emergenciesnotmanaged-list)

import { Injectable } from '@angular/core';
import { Emergenciesnotmanaged } from './emergenciesnotmanaged.model';
import { Subject } from 'rxjs';

@Injectable()
export class EmergenciesnotmanagedService {
  private emergenciesnotmanaged: Emergenciesnotmanaged[] = [];
  emergenciesnotmanagedChanged = new Subject<Emergenciesnotmanaged[]>();
  emergenciesnotmanagedEditMode = new Subject<number>();
  emergenciesnotmanagedcountChanged = new Subject<string>();
  private emergenciesnotmanagedcount: string = '';

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getEmergenciesnotmanaged() {
    return this.emergenciesnotmanaged;
  }
  getEmergenciesnotmanagedcount() {
    return this.emergenciesnotmanagedcount;
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setEmergenciesnotmanaged(emergenciesnotmanaged: Emergenciesnotmanaged[]) {
    if (emergenciesnotmanaged !== null) {
      this.emergenciesnotmanaged = emergenciesnotmanaged;
      if (this.emergenciesnotmanaged) this.emergenciesnotmanagedChanged.next(this.emergenciesnotmanaged.slice()); else this.emergenciesnotmanagedChanged.next([])
    }
  }

  setEmergenciesnotmanagedcount(emergenciesnotmanagedcount: string) {
    if (emergenciesnotmanagedcount !== null) {
      this.emergenciesnotmanagedcount = emergenciesnotmanagedcount;
      this.emergenciesnotmanagedcountChanged.next(this.emergenciesnotmanagedcount.slice());
    }
  } 
}
